import React from 'react';
import { Container, Grid, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import emailjs from '@emailjs/browser';
import { ChevronRight } from '../../helpers/constant/imageUrl';
import AtomButton from '../../atoms/button';
import { ContactFormInputs, contactSchema } from './schemas/contactUsSchema';

// Zod schema


const ContactForm: React.FC = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ContactFormInputs>({
    resolver: zodResolver(contactSchema),
  });

  const onSubmit = (data: ContactFormInputs) => {
    const form = document.createElement('form');
    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.name = key;
      input.value = value || '';
      form.appendChild(input);
    });

    emailjs
      .sendForm(
        'service_lquhnld',  //service id
         'template_b1yobjc', //template id
          form,
           'ElEBzWxD426nCfhUS'  //public key
        )
      .then(
        (result) => {
          console.log('Message Sent:', result.text);
          alert('Message sent successfully!');
          reset();
        },
        (error) => {
          console.error('Send Failed:', error.text);
          alert('Oops! Something went wrong.');
        }
      );
  };

  return (
    <div className="first-step">
      <Container className="container">
        <h2>
          Take the first step <span>We will take care for the rest</span>
        </h2>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} md={7.5}>
            <div className="white-card">
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="First Name"
                      placeholder="First Name"
                      variant="outlined"
                      {...register('first_name')}
                      error={!!errors.first_name}
                      helperText={errors.first_name?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="Product"
                      placeholder="Product"
                      variant="outlined"
                      {...register('product')}
                      error={!!errors.product}
                      helperText={errors.product?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="Phone Number"
                      placeholder="Phone Number"
                      variant="outlined"
                      {...register('phone')}
                      error={!!errors.phone}
                      helperText={errors.phone?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="Email Address"
                      placeholder="Email Address"
                      type="email"
                      variant="outlined"
                      {...register('email_address')}
                      error={!!errors.email_address}
                      helperText={errors.email_address?.message}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      // label="Message"
                      placeholder="Your Message"
                      multiline
                      minRows={4}
                      variant="outlined"
                      {...register('message')}
                      error={!!errors.message}
                      helperText={errors.message?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="Delivery Location"
                      placeholder="Delivery Location (Place)"
                      variant="outlined"
                      {...register('delivery_location')}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      // label="Current Location"
                      placeholder="Current Location"
                      variant="outlined"
                      {...register('current_location')}
                    />
                  </Grid>
                </Grid>
                <div className="mt-8 text-center" style={{ marginTop: '2rem' }}>
                  <AtomButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    endIcon={<img src={ChevronRight} alt="ChevronRight" />}
                  >
                    Request a call
                  </AtomButton>
                </div>
              </form>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ContactForm;
